import { useEffect, useState } from "react";
import { ethers } from "ethers";
import CONTRACT_INFO from "../ContractInfo";

const useProvider = (chainId = CONTRACT_INFO[window.chain].chainId) => {
  const [provider, setProvider] = useState(
    window.ethereum
      ? new ethers.providers.Web3Provider(window.ethereum, chainId)
      : undefined
  );

  const handleProvider = () => {
    setProvider(
      window.ethereum
        ? new ethers.providers.Web3Provider(window.ethereum, chainId)
        : undefined
    );
  };

  useEffect(() => {
    window.addEventListener("ethereum#initialized", handleProvider, {
      once: true,
    });

    setTimeout(handleProvider, 3000); // 3 seconds
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return provider;
};

export default useProvider;
